import {
	type AnyFrontendStage,
	type PlacementFrontendFactory,
	type PlacementBrowserConfig,
} from '@post-office/message-maker-browser/types';

import { createPlacementFrontend } from '@post-office/message-maker-browser/create-placement-frontend';

const placementConfig: PlacementBrowserConfig = {
	placementId: `project-assets-ai-suggestions`,
	options: {
		choreographer: {
			isDefaultEnabled: true,
		},
		hideInIsolatedCloud: false,
	},
};

const placement: {
	createFrontend: PlacementFrontendFactory<{
		render: AnyFrontendStage;
	}>;
} = {
	createFrontend: createPlacementFrontend(placementConfig),
};

export const createFrontend: PlacementFrontendFactory<{
	render: AnyFrontendStage;
}> = placement.createFrontend;
